import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BaseApiResponse, StatusResponse } from '../../../../../../common/interfaces/base-api-response';
import { ServiceError } from '../../../../../../common/models/app/service-error';
import { ApiMngApi, BaseProvider } from '../../../../../../common/providers/base-provider';
import { ApiService } from '../../../../../../common/services/shared/api.service';
import { LoggerService } from '../../../../../../common/services/shared/logger.service';
import { PrivateConfigurationService } from '../../../../../../common/services/shared/private-configuration.service';
import {
    PrepareRejectedTransferCommunicationRequest,
    PrepareRejectedTransferCommunicationResponse
} from './models/rejected-transfer-communication.model';

@Injectable({ providedIn: 'root' })
export class PrepareRejectedTransferCommunicationService extends BaseProvider {
    constructor(
        private api: ApiService,
        private loggerService: LoggerService,
        translateSrv: TranslateService,
        protected configSrv: PrivateConfigurationService
    ) {
        super(configSrv, translateSrv);
    }

    /**
     * @description Effettua la chiamata per preparare la comunicazione di rifiuto voltura
     * @param assetId Identificativo dell'asset del prodotto commodity
     * @returns Observable<PrepareRejectedTransferCommunicationResponse | Error>
     */
    prepareRejectedTransferCommunication(
        assetId: string
    ): Observable<PrepareRejectedTransferCommunicationResponse | Error> {
        const req: PrepareRejectedTransferCommunicationRequest = { assetId };
        return this.api
            .postAsync<
                BaseApiResponse<PrepareRejectedTransferCommunicationResponse>
            >(this.getApiMngApiUrl(ApiMngApi.PrepareRejectedTransferCommunication), req)
            .pipe(
                tap((response) => {
                    if (response?.status !== StatusResponse.Success) {
                        throw new ServiceError(
                            response?.errorManagement?.errorCode,
                            response?.errorManagement?.errorDescription
                        );
                    }
                }),
                map((res) => res?.response),
                catchError((error: Error) => {
                    this.loggerService.error(
                        'Errore chiamata PrepareRejectedTransferCommunication',
                        error?.message,
                        error,
                        true
                    );
                    return of(error);
                })
            );
    }
}
